// AKSU Business School - LMS Authentication & RBAC Hierarchy
// Domain: businessschool.aksu.edu.ng
// British English throughout

export const USER_ROLES = {
  DIRECTOR: 'director',
  CONTENT_MANAGER: 'content-manager',
  FACULTY: 'faculty',
  STUDENT: 'student'
};

export const AUTH_CREDENTIALS = [
  {
    id: 'user-director',
    role: USER_ROLES.DIRECTOR,
    label: "Executive Director (Global Admin)",
    name: "Dr Uwem Etim Uwah",
    title: "Acting Director, AKSU Business School",
    qualifications: "PhD, FCA, ACTI",
    email: "uwemuwah@aksu.edu.ng",
    demoUsername: "director@businessschool.aksu.edu.ng",
    demoPassword: "Director@AKSU2026",
    department: "Department of Accounting",
    badge: "GLOBAL ADMIN · SENATE DESK",
    leastPrivilegeTier: "Tier 1: Global Institutional & Senate Authority",
    permissions: [
      "Access school-wide financial settlements & Paystack gateway",
      "Executive Senate approvals & Doctoral defence clearances",
      "School-wide cohort analytics & NUC quality assurance",
      "Global administrative oversight across all LMS portals"
    ],
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200&auto=format&fit=crop"
  },
  {
    id: 'user-manager',
    role: USER_ROLES.CONTENT_MANAGER,
    label: "LMS Global Content Manager (Global Admin)",
    name: "Engr. Dr Inemesit Udofia",
    title: "Chief Academic Technology Officer & Global LMS Administrator",
    qualifications: "PhD, FNCS, MCPN",
    email: "content.manager@businessschool.aksu.edu.ng",
    demoUsername: "content.manager@businessschool.aksu.edu.ng",
    demoPassword: "LMSAdmin@AKSU2026",
    department: "Directorate of Academic Computing & E-Learning",
    badge: "GLOBAL LMS MASTER · CURRICULUM ARCHITECT",
    leastPrivilegeTier: "Tier 1: Global Curriculum & Content Governance",
    permissions: [
      "Master control over all 6 Programme curricula & course syllabi",
      "Manage and publish LMS module components (Slides, Cases, Videos)",
      "Audit and approve faculty learning material submissions",
      "Assign faculty chairs to executive course modules",
      "Enforce student cohort access rules and Bursary clearance gates",
      "System-wide activity logging and LMS security configuration"
    ],
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop"
  },
  {
    id: 'user-faculty',
    role: USER_ROLES.FACULTY,
    label: "Executive Faculty Chair (Scoped Access)",
    name: "Prof. Asuquo E. Johnson",
    title: "Professor of Strategic Management & Corporate Governance",
    qualifications: "PhD, FNIM, FIMC",
    email: "prof.johnson@businessschool.aksu.edu.ng",
    demoUsername: "prof.johnson@businessschool.aksu.edu.ng",
    demoPassword: "Faculty@AKSU2026",
    department: "Department of Business Administration",
    badge: "SCOPED FACULTY · DBA 911 & MGT 801",
    leastPrivilegeTier: "Tier 2: Course-Scoped Academic Authority",
    assignedCourses: ["DBA 911", "MGT 801"],
    permissions: [
      "Targeted upload of slides, cases, and videos to assigned modules only",
      "Review and grade executive coursework for assigned enrolled students",
      "View enrolled candidate rosters for DBA 911 & MGT 801",
      "Restricted: Cannot alter global curriculum, tuition, or other faculties' courses"
    ],
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop"
  },
  {
    id: 'user-student-dba',
    role: USER_ROLES.STUDENT,
    studentId: 'student-dba',
    label: "Executive Doctoral Scholar (DBA Track)",
    name: "Emem Udoh",
    matric: "AKSU/BS/2026/DBA/012",
    programme: "Doctor of Business Administration (DBA)",
    email: "emem.udoh@student.aksu.edu.ng",
    demoUsername: "emem.udoh@student.aksu.edu.ng",
    demoPassword: "Scholar@AKSU2026",
    badge: "ENROLLED SCHOLAR · DBA COHORT 2026",
    leastPrivilegeTier: "Tier 3: Enrolled Learner Access",
    cohort: "2025/2026 Executive Intake",
    clearanceStatus: "Bursary & Acceptance Cleared",
    permissions: [
      "Stream lecture videos and download DBA module slide decks",
      "Submit executive case studies and capstone research briefs",
      "View personal grades, attendance records, and faculty feedback",
      "Restricted: Cannot access other programmes, unapproved drafts, or grading desks"
    ],
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop"
  },
  {
    id: 'user-student-phd',
    role: USER_ROLES.STUDENT,
    studentId: 'student-phd',
    label: "Doctoral Research Fellow (PhD Track)",
    name: "Idorenyin Bassey",
    matric: "AKSU/BS/2026/PHD/004",
    programme: "PhD in Business Administration",
    email: "idorenyin.bassey@student.aksu.edu.ng",
    demoUsername: "idorenyin.bassey@student.aksu.edu.ng",
    demoPassword: "Scholar@AKSU2026",
    badge: "ENROLLED SCHOLAR · PHD COHORT 2026",
    leastPrivilegeTier: "Tier 3: Enrolled Learner Access",
    cohort: "2025/2026 Executive Intake",
    clearanceStatus: "50% Session Tuition Paid & Cleared",
    permissions: [
      "Access doctoral research seminars, econometrics modules, and readings",
      "Submit doctoral dissertation chapters and proposal drafts",
      "View supervisor notes and colloquium dates"
    ],
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200&auto=format&fit=crop"
  },
  {
    id: 'user-student-mba',
    role: USER_ROLES.STUDENT,
    studentId: 'student-mba',
    label: "Executive MBA Scholar (MBA Track)",
    name: "Aniefiok Okon",
    matric: "AKSU/BS/2026/MBA/028",
    programme: "Master of Business Administration (MBA)",
    email: "aniefiok.okon@student.aksu.edu.ng",
    demoUsername: "aniefiok.okon@student.aksu.edu.ng",
    demoPassword: "Scholar@AKSU2026",
    badge: "ENROLLED SCHOLAR · MBA COHORT 2026",
    leastPrivilegeTier: "Tier 3: Enrolled Learner Access",
    cohort: "October 2026 Executive Intake",
    clearanceStatus: "Bursary & Acceptance Cleared",
    permissions: [
      "Stream executive MBA lectures and corporate case analysis videos",
      "Submit managerial finance and corporate strategy capstone assignments",
      "Participate in syndicate discussion forums and view gradebook"
    ],
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop"
  },
  {
    id: 'user-student-pgd',
    role: USER_ROLES.STUDENT,
    studentId: 'student-pgd',
    label: "Postgraduate Diploma Scholar (PGD Track)",
    name: "Itoro Akpan",
    matric: "AKSU/BS/2026/PGD/055",
    programme: "Postgraduate Diploma in Business Administration (PGD)",
    email: "itoro.akpan@student.aksu.edu.ng",
    demoUsername: "itoro.akpan@student.aksu.edu.ng",
    demoPassword: "Scholar@AKSU2026",
    badge: "ENROLLED SCHOLAR · PGD COHORT 2026",
    leastPrivilegeTier: "Tier 3: Enrolled Learner Access",
    cohort: "October 2026 Executive Intake",
    clearanceStatus: "Bursary & Acceptance Cleared",
    permissions: [
      "Access foundational management coursework and quantitative study packs",
      "Submit weekly module assessments and business case reviews",
      "Track pathway progress toward executive masters progression"
    ],
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop"
  }
];

// Master Course & Module Taxonomy for Bulletproof Targeting
export const LMS_MASTER_CURRICULUM = [
  {
    courseCode: "DBA 911",
    courseTitle: "Strategic Leadership & Corporate Turnaround",
    programme: "Doctor of Business Administration (DBA)",
    programmeId: "dba",
    leadFaculty: "Prof. Asuquo E. Johnson",
    semester: "First Term 2026",
    targetCohort: "2025/2026 Executive Intake (6 Cleared Candidates)",
    enrolledStudentCount: 6,
    modules: [
      {
        id: "MOD-DBA-911-01",
        number: 1,
        title: "Corporate Turnaround & Crisis Diagnostics in Emerging Economies",
        status: "Active / Published",
        components: [
          { slot: "slides", label: "Executive Lecture Slides (PDF/PPT)", file: "DBA911_Mod1_Slides_v2.pdf", size: "4.8 MB", date: "12 Oct 2026", status: "Published" },
          { slot: "case-study", label: "Harvard / Industry Case Study", file: "Turnaround_Nigerian_Conglomerates_Case.pdf", size: "2.1 MB", date: "15 Oct 2026", status: "Published" },
          { slot: "video", label: "Executive Video Recording", file: "DBA911_Session_Turnaround_HD.mp4", size: "480 MB", date: "17 Oct 2026", status: "Published" },
          { slot: "dataset", label: "Quantitative Financial Model", file: "Altman_Z_Score_Distress_Model.xlsx", size: "1.4 MB", date: "18 Oct 2026", status: "Published" },
          { slot: "assignment", label: "Capstone Problem Brief", file: "DBA911_Deliverable_01.pdf", size: "650 KB", date: "18 Oct 2026", status: "Published" }
        ]
      },
      {
        id: "MOD-DBA-911-02",
        number: 2,
        title: "Strategic Value Innovation & Blue Ocean Paradigms",
        status: "Active / Published",
        components: [
          { slot: "slides", label: "Executive Lecture Slides (PDF/PPT)", file: "DBA911_Mod2_BlueOcean_Slides.pdf", size: "5.2 MB", date: "16 Oct 2026", status: "Published" },
          { slot: "case-study", label: "Harvard / Industry Case Study", file: "Value_Innovation_West_Africa_Case.pdf", size: "3.4 MB", date: "16 Oct 2026", status: "Published" },
          { slot: "video", label: "Executive Video Recording", file: "DBA911_Mod2_Lecture_Live.mp4", size: "520 MB", date: "17 Oct 2026", status: "Published" }
        ]
      },
      {
        id: "MOD-DBA-911-03",
        number: 3,
        title: "Boardroom Governance & Shareholder Activism in Sub-Saharan Africa",
        status: "Scheduled / Drafting",
        components: [
          { slot: "slides", label: "Executive Lecture Slides (PDF/PPT)", file: "Pending Faculty Upload", size: "-", date: "-", status: "Awaiting Upload" }
        ]
      },
      {
        id: "MOD-DBA-911-04",
        number: 4,
        title: "Executive Mergers, Acquisitions & High-Stakes Negotiations",
        status: "Scheduled / Drafting",
        components: [
          { slot: "slides", label: "Executive Lecture Slides (PDF/PPT)", file: "Pending Faculty Upload", size: "-", date: "-", status: "Awaiting Upload" }
        ]
      }
    ]
  },
  {
    courseCode: "MGT 801",
    courseTitle: "Advanced Corporate Governance & Enterprise Ethics",
    programme: "Master of Business Administration (MBA)",
    programmeId: "mba",
    leadFaculty: "Prof. Asuquo E. Johnson",
    semester: "First Term 2026",
    targetCohort: "2025/2026 MBA Executive Stream",
    enrolledStudentCount: 6,
    modules: [
      {
        id: "MOD-MGT-801-01",
        number: 1,
        title: "Comparative Corporate Governance Frameworks (UK, OECD & Nigerian Code 2018)",
        status: "Active / Published",
        components: [
          { slot: "slides", label: "Executive Lecture Slides (PDF/PPT)", file: "MGT801_Mod1_Governance.pdf", size: "3.8 MB", date: "14 Oct 2026", status: "Published" },
          { slot: "case-study", label: "Industry Case Study", file: "Governance_Failure_Banking_Case.pdf", size: "2.6 MB", date: "15 Oct 2026", status: "Published" }
        ]
      },
      {
        id: "MOD-MGT-801-02",
        number: 2,
        title: "Fiduciary Responsibilities, ESG Mandates & Carbon Accounting",
        status: "Active / Published",
        components: [
          { slot: "slides", label: "Executive Lecture Slides (PDF/PPT)", file: "MGT801_Mod2_ESG_Mandates.pdf", size: "4.1 MB", date: "17 Oct 2026", status: "Published" }
        ]
      }
    ]
  },
  {
    courseCode: "PHD 901",
    courseTitle: "Advanced Quantitative Research Methodology & Econometrics",
    programme: "Doctor of Philosophy in Business Administration (PhD BA)",
    programmeId: "phd-ba",
    leadFaculty: "Prof. Nse Essien / Prof. N. A. Udoka",
    semester: "First Term 2026",
    targetCohort: "2025/2026 Doctoral Research Scholars",
    enrolledStudentCount: 3,
    modules: [
      {
        id: "MOD-PHD-901-01",
        number: 1,
        title: "Epistemological Paradigms & Structural Equation Modeling (PLS-SEM)",
        status: "Active / Published",
        components: [
          { slot: "slides", label: "Doctoral Seminar Slides (PDF)", file: "PHD901_PLS_SEM_Foundations.pdf", size: "6.2 MB", date: "10 Oct 2026", status: "Published" },
          { slot: "dataset", label: "Empirical Stata / R Dataset", file: "Industrial_Survey_Wave1.dta", size: "18.5 MB", date: "12 Oct 2026", status: "Published" }
        ]
      }
    ]
  }
];
